<input
        #input
        (keydown)="onKeyDown($event)"
        [(ngModel)]="value"
/>
